module.exports = __webpack_public_path__ + "static/media/vk_icon_btn.1dce67a8.svg";